// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"246":"efd35244","922":"c0de8336"}[chunkId] + ".css";
};